var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Verify" },
    [
      _vm.verifyStatus == 1
        ? [
            _c("upDataIDQr", {
              attrs: { classId: _vm.currentClassId },
              on: { getData: _vm.getDataFn },
            }),
          ]
        : _vm.verifyStatus == 2
        ? [
            _vm.isFace
              ? _c("Face", {
                  ref: "face",
                  attrs: { classId: _vm.currentClassId },
                  on: {
                    isValidationFace: _vm.isValidationFace,
                    isRouter: _vm.isRouter,
                  },
                })
              : _vm._e(),
          ]
        : _vm.verifyStatus == 3
        ? [_vm._m(0)]
        : _vm.verifyStatus == 4
        ? [
            _c("div", { staticClass: "pay", staticStyle: { width: "410px" } }, [
              _vm._m(1),
              _c("div", { staticClass: "pay-title" }, [
                _vm._v("等待缴费......"),
              ]),
              _c("p", [
                _vm._v(
                  "学生： " +
                    _vm._s(_vm.studentInfo.title) +
                    "，你的学号是：" +
                    _vm._s(_vm.studentInfo.student_code)
                ),
              ]),
              _c("p", [_vm._v("请按照下方缴费方式进行缴费")]),
              _c("p", [
                _vm._v(
                  "关注重庆医科大学财务处公众号—点击服务大厅—点击统一支付平台—点击特殊登录—输入学号和密码—点击成教及自考缴费—缴费完成后，等待10-15分钟入账—10-15分钟后返回主页点击票据查询——即可获得缴费电子票据"
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _c(
        "el-button",
        {
          staticClass: "exit-btn",
          attrs: { type: "primary" },
          on: { click: _vm.exit },
        },
        [_vm._v("退出登录")]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pay" }, [
      _c("div", { staticClass: "pay-icon" }, [
        _c("img", {
          staticClass: "img",
          attrs: { src: require("../../assets/images/icon_pay.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "pay-title" }, [
        _vm._v("等待跳转到E签宝......"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pay-icon" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("../../assets/images/icon_pay.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }